
import BaseInput from '@/components/BaseInput.vue'
import IconSearch from '@/components/svg/IconSearch.vue'
import { SAVE_BARCODE_SEARCH_PARAMS } from '@/store/actions'
import { EBCRType, ECustomFieldType, EOCRType } from '@/utils/enums'
import errorHandler from '@/utils/errorHandler'
import { IBarcodeSearchForm, TError } from '@/utils/types/commonTypes'
import { Options, Vue } from 'vue-class-component'
@Options({
  components: { IconSearch, BaseInput },
  name: 'BarcodeSearchPage',
})
export default class BarcodeSearchPage extends Vue {
  searchType = 'tracking-number'
  trackingNumberKey = 'TPNumber'
  trackingNumber = ''
  externalId = ''
  isLoading = false

  get projectDetail() {
    return this.$store.state.project.details
  }

  get fieldSchema() {
    return {
      fieldType: ECustomFieldType.TEXT,
      ocrReaderType: EOCRType.DEFAULT,
      barcodeReaderType: EBCRType.DEFAULT,
    }
  }

  get isDisableSearchButton() {
    return (
      (this.searchType === 'external-id' && !this.externalId) ||
      (this.searchType === 'tracking-number' && !this.trackingNumber)
    )
  }

  // searchConditions: [{ key: 'projectId', valueType: 'string', value: this.projectDetail.id }],
  async searchBarcode() {
    try {
      const countPerPage = Math.round((window.innerHeight - 130) / 100)
      const searchForm: IBarcodeSearchForm = {
        projectCode: this.projectDetail?.code,
        version: this.$store.getters.projectVersion,
        searchConditionBlocks: [
          {
            searchConditions: [{ key: 'projectId', valueType: 'string', value: this.projectDetail.id }],
            logicalOperator: 'and',
          },
        ],
        logicalOperator: 'and',
        count: countPerPage,
        skip: 0,
        sortOrder: -1,
        sortKey: 'audit.createdDateTime',
      }

      if (this.searchType === 'tracking-number') {
        const trackingNumberSearchItem = {
          key: 'activationData.trackingNumber',
          valueType: 'string',
          value: this.trackingNumber,
        }
        if (searchForm.searchConditionBlocks[0].searchConditions) {
          searchForm.searchConditionBlocks[0].searchConditions.push(trackingNumberSearchItem)
        }
      }

      if (this.searchType === 'external-id') {
        const externalNumberSearchItem = {
          key: 'activationData.externalId',
          valueType: 'string',
          value: this.externalId,
        }
        if (searchForm.searchConditionBlocks[0].searchConditions) {
          searchForm.searchConditionBlocks[0].searchConditions.push(externalNumberSearchItem)
        }
      }

      this.isLoading = true
      const condition = { condition: searchForm }

      this.$store.commit(SAVE_BARCODE_SEARCH_PARAMS, condition)

      this.$router.push({
        name: 'barcodeListPage',
        params: { searchCondition: JSON.stringify(condition) },
        query: this.flatternConditions(searchForm),
      })
    } catch (e) {
      errorHandler(e as TError)
    }
  }

  flatternConditions({ searchConditionBlocks, ...others }: IBarcodeSearchForm) {
    const conditionKeys: Record<string, string> = (searchConditionBlocks[0].searchConditions ?? []).reduce(
      (acc, item, idx) => ({
        ...acc,
        [`key_${idx}`]: item.key,
        [`valueType_${idx}`]: item.valueType,
        [`value_${idx}`]: item.value,
      }),
      {}
    )

    return { ...others, ...conditionKeys }
  }
}
